import { Alert, Button, Paper, TextField, Typography } from '@mui/material'
import axios from 'axios'
import { AuthenticationBearerJWT } from 'chezy-inventory-backend/bin/auth/AuthenticationContext'
import { Inventory } from 'chezy-inventory-backend/bin/database/types/Inventory'
import { useFormik } from 'formik'
import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import * as yup from 'yup'

import ChezyLogo from '../../cc_logo.jpg'
import { AuthContext } from '../../utils/authContext'
import { getBaseURL } from '../../utils/getBaseURL'

export const Login = () => {
  const authContext = useContext(AuthContext)
  const location = useLocation()
  const navigate = useNavigate()
  const [alert, setAlert] = useState(false)

  const validationSchema = yup.object({
    username: yup.string().required(),
    password: yup.string().required(),
  })

  const formik = useFormik<{ username: string; password: string }>({
    initialValues: { username: '', password: '' },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setAlert(false)
      axios
        .post(`${getBaseURL()}/login`, values)
        .then(
          ({ data }: { data: { token: string; authorization: AuthenticationBearerJWT; inventories: Inventory[] } }) => {
            authContext.setJwt(data.token)
            authContext.setTokenData(data.authorization)
            authContext.setPermittedInventories(data.inventories)
          }
        )
        .catch((err) => {
          setAlert(true)
          authContext.setJwt(undefined)
          authContext.setTokenData(undefined)
          authContext.setPermittedInventories([])
        })
    },
  })

  useEffect(() => {
    if (authContext.jwt) {
      const loc = location.state as unknown as { from?: Location }
      if (loc?.from) {
        navigate(loc.from)
      } else {
        navigate('/')
      }
    }
  }, [authContext, location, navigate])

  return (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
      <div>
        <img src={ChezyLogo} width={100} alt="Chezy Champs logo" />
      </div>
      <Paper elevation={4} style={{ maxWidth: 500, padding: 20, width: 'calc(100% - 40px)', margin: 20 }}>
        <form onSubmit={formik.handleSubmit} style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
          <Typography variant="h4">Log In</Typography>
          {alert && <Alert severity="error">Login failed.</Alert>}
          <TextField
            autoFocus
            id="name"
            label={'Username'}
            type="text"
            fullWidth
            name="username"
            variant="outlined"
            value={formik.values.username}
            onChange={formik.handleChange}
            error={formik.touched.username && Boolean(formik.errors.username)}
            helperText={formik.touched.username && formik.errors.username}
          />
          <TextField
            id="description"
            name="password"
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Save
          </Button>
        </form>
      </Paper>
    </div>
  )
}
